const filtersResourceName=(val) =>{
    let collectType = [
      { categoryName: "全部", categoryCode: "" },
      { categoryName: "图书", categoryCode: "ts" },
      { categoryName: "标准规范", categoryCode: "bz" },
      { categoryName: "课程", categoryCode: "ck" },
      { categoryName: "试卷", categoryCode: "sj" },
      { categoryName: "图片", categoryCode: "tp" },
      { categoryName: "视频", categoryCode: "sp" },
      { categoryName: "案例", categoryCode: "al" },
      { categoryName: "图库", categoryCode: "zlj" },
      { categoryName: "配套资源(网络下载)", categoryCode: "ptzy" },
      { categoryName: "文章", categoryCode: "wz" },
      { categoryName: "连续出版物", categoryCode: "lxcbw" },
      { categoryName: "电子表格", categoryCode: "dzbg" },

    ];
    for (var i = 0; i < collectType.length; i++) {
      if (collectType[i].categoryCode === val) {
        return collectType[i].categoryName;
      }
    }
  }

  module.exports={
    filtersResourceName
  }


// WEBPACK FOOTER //
// ./src/utils/globalFilters.js